<template>
  <div class="container" @click="maskClose">
    <div class="content-wrap">
      <div class="content" :class="'bg_' + prize.prize_value">
        <img
          class="close"
          src="../../../../images/money_tree/dialog/close.png"
          @click="onClose"
        />
        <div
          v-if="[66, 666, 6666].indexOf(prize.prize_value) === -1"
          class="coupon-wrap"
        >
          <div class="coupon">
            <div class="value-wrap">
              <span class="unit">￥</span>
              <span class="value">{{ prize.prize_value || '' }}</span>
            </div>
            <div class="label">优惠劵</div>
          </div>
        </div>
        <div class="go-to-wrap">
          <img
            class="btn-go"
            src="../../../../images/money_tree/dialog/btn_go_2021.png"
            @click="onGoMyCoupon"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    prize: {
      type: Object,
      default: null
    }
  },
  methods: {
    onClose() {
      this.$emit('close')
    },
    maskClose() {
      this.$emit('close')
    },

    /**
     * 去查看-跳转到我的优惠卷页面
     */
    onGoMyCoupon() {
      this.$emit('close')
      this.$nativeRedirect(this.$nativeRoutes.myCoupons)
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  display: flex;

  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;

  flex-direction: column;
  justify-content: center;

  .content-wrap {
    display: flex;

    flex-direction: column;
    justify-content: center;
    align-items: center;

    .content {
      position: relative;

      width: 5.5rem;
      height: 6.6rem;
      overflow: hidden;

      background-image: url('../../../../images/money_tree/dialog/win_bg_2021.png');

      background-repeat: no-repeat;
      background-size: 100% 100%;
      &.bg_66 {
        background-image: url('../../../../images/money_tree/dialog/66.png');
      }
      &.bg_666 {
        background-image: url('../../../../images/money_tree/dialog/666.png');
      }
      &.bg_6666 {
        background-image: url('../../../../images/money_tree/dialog/6666.png');
      }

      .close {
        position: absolute;
        top: 0;
        right: 0;

        width: 0.79rem;
        height: 0.79rem;
      }

      .coupon-wrap {
        display: flex;

        position: absolute;

        bottom: 2rem;

        left: 0;

        width: 100%;

        flex-direction: column;
        justify-content: center;
        align-items: center;

        .coupon {
          flex-direction: column;
          justify-content: center;
          align-items: center;

          .value-wrap {
            .unit {
              font-size: 0.28rem;
              color: #a74400;
            }

            .value {
              font-size: 0.48rem;
              color: #a74400;
            }
          }

          .label {
            margin-top: 0.3rem;

            font-size: 0.36rem;
            text-align: center;
            color: #a74400;
          }
        }
      }

      .go-to-wrap {
        position: absolute;
        bottom: 0;
        left: 0;

        width: 100%;

        text-align: center;

        .btn-go {
          width: 2.5rem;
          height: 1.06rem;
          overflow: hidden;

          background-image: url('../../../../images/money_tree/dialog/btn_go_2021.png');

          background-repeat: no-repeat;
          background-size: 100% 100%;
        }
      }
    }
  }
}
</style>
